<template>
    <el-dialog custom-class="share_dialog" :model-value="show" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="share_artcle_dialog" v-loading="loading">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-fenxiang"></i></div>
            <h1>分享文章</h1>
            <h2>文章链接分享，请选择有效期</h2>
            <div class="form_item border">
                <span class="name">有效期：</span>
                <el-radio-group v-model="expire" @change="getShareToken">
                    <el-radio :label="-1">不限</el-radio>
                    <el-radio :label="7">7天</el-radio>
                    <el-radio :label="30">30天</el-radio>
                </el-radio-group>
            </div>
            <div class="form_item">
                <span class="name">二维码：</span>
                <div class="qr_img">
                    <vueQr :text="shareLinkWithToken" :size="400" />
                </div>
            </div>
            <div class="btn_box">
                <button @click="copyLink">复制链接</button>
                <button @click="handleClose">取消</button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, computed } from "vue";
import { Close } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { apiWeeklyShareCreate } from "@/request/api";
import copyText from "@/utils/copyText";
import { ElMessage } from "element-plus";
import vueQr from "vue-qr/src/packages/vue-qr.vue";

const props = defineProps({
    show: { type: Boolean, default: false },
    row: { type: Object, default: {} },
});
const emits = defineEmits(["close"]);
const route = useRoute();
const expire = ref(-1);
const loading = ref(false);
const shareToken = ref("");
// 分享链接(没有分享token，用于传给后端获取分享token)
const shareLink = computed(() => {
    const articleId = route.query.articleId || props.row.articleId;
    const tagId1 = route.query.tagId1 || props.row.tagId;
    let link = window.location.origin + `/details?articleId=${articleId}&tagId1=${tagId1}&isArt=true&share=`;
    return link;
});
// 分享链接(有分享token，用于复制和二维码)
const shareLinkWithToken = computed(() => {
    return `${shareLink.value}${shareToken.value}`;
});

// 点击复制链接
const copyLink = () => {
    copyText(shareLinkWithToken.value);
    ElMessage.success("复制成功");
    handleClose();
};

// 获取分享token
async function getShareToken() {
    loading.value = true;
    try {
        const articleId = route.query.articleId || props.row.articleId;
        const params = { shareLink: shareLink.value, expire: expire.value, articleId };
        const { code, data } = await apiWeeklyShareCreate(params);
        if (code !== "0") return;
        shareToken.value = data || "";
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {
    getShareToken();
}

// 关闭
function handleClose() {
    expire.value = -1;
    loading.value = false;
    emits("close");
}
</script>

<style lang="scss">
.share_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .share_artcle_dialog {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .form_item {
            display: flex;
            align-items: center;
            padding: 10px 0;
            &.border {
                border-bottom: 2px solid #f0f0f0;
            }
            span {
                font-size: 18px;
                &.name {
                    color: #727272;
                    padding-right: 2px;
                }
            }
            .qr_img {
                width: 200px;
                img {
                    width: 100%;
                }
            }
        }
        .btn_box {
            // padding-top: 48px;
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
